export default "__VITE_ASSET__BjZNC9Qg__"